const questions = [
  [
    "How does WinIt work?",
    "WinIt's specialists will dispute your ticket on your  behalf. If your is dismissed, we only charge 50% of the ticket amount."
  ],
  [
    "Why do I need to add my CC?",
    "We save your payment details up front to verify your account. We won't charge anything for this dispute until you WinIt!"
  ],
  [
    "What happens if the dispute is lost?",
    "If we can't beat your ticket, we'll notify you promptly, and you'll have another 30 days to pay your fine without additional court fees."
  ],
  [
    "Will I incur late court fees?",
    "Tickets submitted at least 7 business days before the next Late Fee Deadline are guaranteed to not incur any penalties while waiting for a hearing. You can contact WinIt support at any time to check the status of your ticket."
  ]
]

export default questions
